import { useGeneralStore } from 'src/store';

// onehealth product brand mark is static (not configurable per channel).
export const ONEHEALTH_LOGO = '/images/landing/logo-onehealth.png';

export interface ResolvedLanding {
  enabled: boolean;
  caption: string;
  hero: string;
  secondary: string;
  qualify: string;
  productLogo: string;
  partnerLogo: string;
}

const MOCK = {
  hero: '/images/landing/herobg.png',
  secondary: '/images/landing/secondary.png',
  qualify: '/images/landing/qualify.png',
  partnerLogo: '/images/landing/logo-nysar.png',
};

export function useLandingSettings(): ResolvedLanding {
  const siteConfig = useGeneralStore((s) => s.siteConfig);
  const landing = siteConfig?.landing;

  return {
    enabled: landing?.enabled ?? true,
    caption: landing?.caption || '',
    hero: landing?.hero || MOCK.hero,
    secondary: landing?.secondary || MOCK.secondary,
    qualify: landing?.qualify || MOCK.qualify,
    //productLogo: ONEHEALTH_LOGO,
    //partnerLogo: siteConfig?.logo || MOCK.partnerLogo,
    productLogo: siteConfig?.logo || MOCK.partnerLogo,
    partnerLogo: '',
  };
}
